import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @Input() amount: number = 0;
  @Input() goal: number = 0;
  @Input() height = '6px';
  percentage;


  ngOnChanges() {
    this.setProgressbar();
  }
  /** Set progress bar */
  setProgressbar(): void {
    const amount = this.amount;
    const goal = this.goal;
    this.percentage = (amount / goal) * 100 + '%';
  }

}
